import { type SVGProps } from 'react'

/**
 * Olive icon - represents the app's credit currency.
 * Uses currentColor for flexible styling via className or style.
 *
 * @example
 * // Inherit text color
 * <OliveIcon className="w-4 h-4" />
 *
 * // Custom color
 * <OliveIcon className="w-4 h-4 text-green-500" />
 */
export function OliveIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 113 141" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M56.5 0C87.7041 0 113 31.5639 113 70.5C113 109.436 87.7041 141 56.5 141C25.2959 141 0 109.436 0 70.5C0 31.5639 25.2959 0 56.5 0ZM100.388 67.5029C99.0086 67.5649 97.9412 68.7331 98.0029 70.1123C98.2372 75.3473 97.1719 83.4365 94.792 91.4102C92.3981 99.4306 88.8051 106.887 84.2783 111.188C83.2773 112.138 83.2366 113.721 84.1875 114.722C85.1384 115.723 86.7207 115.763 87.7217 114.812C93.1948 109.613 97.1019 101.153 99.583 92.8398C102.078 84.4805 103.263 75.8193 102.997 69.8877C102.935 68.5086 101.767 67.4412 100.388 67.5029ZM56.5 19C42.4167 19 31 26.6112 31 36C31 45.3888 42.4167 53 56.5 53C70.5833 53 82 45.3888 82 36C82 26.6112 70.5833 19 56.5 19Z" />
    </svg>
  )
}
